import { createConnectQueryKey } from '@connectrpc/connect-query'
import { listApprovalTasks } from '@ebalance/proto/bffuser/v1/approval_task_service-ApprovalTaskService_connectquery'

/**
 * 承認案件一覧の React Query キー。
 * Transition RPC (承認/差戻し) の onSuccess で invalidate するために使う。
 */
export const approvalTasksQueryKeys = {
  list: createConnectQueryKey({
    schema: listApprovalTasks,
    cardinality: 'finite',
  }),
} as const
